import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useOutletContext, useParams } from "react-router";
import NotificationDetailsForm from "../../../../components/Admin/EngagementCenter/NotificationDetailsForm/NotificationDetailsForm";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { getNotificationByIdActionHandler } from "../../../../store/actions/actionHandlers/adminActionHandler/engagementCenterActionHandler";
import { engagementCenter } from "../../../../utils/mainTabs/admin/engagementCenter/engagementCenter";
import { notificationDetails } from "../../../../utils/mainTabs/admin/engagementCenter/notificationDetails";
import { timeZones } from "../../../../utils/timeZones";

const NotificationDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const { tenantName } = useOutletContext();

  const { formData } = notificationDetails;
  const editNotificationPath = engagementCenter.editNotificationPath(
    tenantName,
    params?.notificationId
  );

  const [formValues, setFormValues] = useState(null);

  useEffect(() => {
    if (location.pathname === editNotificationPath) {
      dispatch(getNotificationByIdActionHandler(params?.notificationId)).then(
        (data) => {
          if (data?.NotificationTypeId === 1) {
            setFormValues({
              ...data,
              EventValues: [
                {
                  Key: data?.EventValueId,
                  Value: data?.EventValue,
                },
              ],
              PlaceHolderEventValues: [
                {
                  Key: data?.PlaceHolderEventValueId,
                  Value: data?.PlaceHolderEventValue,
                },
              ],
            });
          } else if (data?.NotificationTypeId === 2) {
            const timeArr = data?.FormattedNotifyIn.split(" ");
            const timezone = timeArr.pop();
            const timeZoneSelectedValue = timeZones.find(
              (val) => val.Id === timezone
            );
            const formatDateTime1 = new Date(timeArr.join(" "));
            const localtimezone =
              formatDateTime1.getTimezoneOffset() * 60 * 1000;
            let formatDateTime2 = formatDateTime1 - localtimezone;
            let formatDateTime3 = new Date(formatDateTime2);
            let formatIsoDate1 = formatDateTime3.toISOString();
            let formatIsoDate2 = formatIsoDate1.split(".")[0];
            let formatIsoDate3 = formatIsoDate2.replace("T", " ");
            const formatDateTime4 = formatIsoDate3.split(":");
            formatDateTime4.pop();
            const datetime = formatDateTime4.join(":");
            setFormValues({
              ...data,
              StartDateAndTime: datetime,
              Timezones: timeZoneSelectedValue.Id,
            });
          } else {
            setFormValues(data);
          }
        }
      );
    } else {
      setFormValues(formData);
    }
  }, [
    dispatch,
    editNotificationPath,
    formData,
    location.pathname,
    params?.notificationId,
  ]);

  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <NotificationDetailsForm formValues={formValues} />
    </BoxLayout>
  );
};

export default NotificationDetails;
